import { Timestamp } from "firebase/firestore";

const getMilliseconds = (timestamp: Timestamp) => {
	return timestamp.seconds * 1000 + timestamp.nanoseconds / 10000000;
};

export default getMilliseconds;
